import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import SectionCard from "@/components/customers/SectionCard";
import { useCanLinkFreelanceSuppliers, useFreelancerSupplierLinks, useRemoveSupplierLink } from "@/hooks/use-freelancer-suppliers";

/**
 * VIB-2934: leverandørene i PowerOffice som er koblet til frilanseren. Bilagene
 * fra dem gir prosjekthistorikken. Vises bare når frilans på prosjekt er på.
 */
export function FreelancerSupplierCard({ freelancerId }: { freelancerId: string }) {
  const { data: links = [] } = useFreelancerSupplierLinks();
  const canLink = useCanLinkFreelanceSuppliers();
  const remove = useRemoveSupplierLink();
  const mine = links.filter((l) => l.freelancer_id === freelancerId);
  if (mine.length === 0) return null;

  return (
    <SectionCard title="Leverandør i PowerOffice" compact meta={mine.length > 1 ? String(mine.length) : undefined}>
      <ul className="divide-y divide-border">
        {mine.map((l) => (
          <li key={l.id} className="space-y-1.5 px-4 py-3">
            <div className="flex items-center justify-between gap-2">
              <div className="min-w-0">
                <div className="truncate text-sm font-medium">{l.supplier_name}</div>
                <div className="text-xs text-muted-foreground">{l.po_supplier_id ? `Leverandør-ID ${l.po_supplier_id}` : "Koblet på navn"}</div>
              </div>
              <Badge variant="secondary" className="shrink-0 px-2 text-xs">Koblet</Badge>
            </div>
            {canLink && (
              <Button
                variant="link"
                size="sm"
                className="h-auto p-0 text-xs text-muted-foreground"
                disabled={remove.isPending}
                onClick={() => remove.mutate({ linkId: l.id, freelancerId })}
              >
                Fjern kobling
              </Button>
            )}
          </li>
        ))}
      </ul>
    </SectionCard>
  );
}
